import { Selector } from "../../components/ui";

export type RunFilter =
  | "all"
  | "draft"
  | "queued"
  | "active"
  | "succeeded"
  | "failed"
  | "canceled"
  | "expired";

export const RUN_FILTERS: readonly { value: RunFilter; label: string }[] = [
  { value: "all", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "queued", label: "Queued" },
  { value: "active", label: "Running" },
  { value: "succeeded", label: "Succeeded" },
  { value: "failed", label: "Failed" },
  { value: "canceled", label: "Canceled" },
  { value: "expired", label: "Expired" },
];

export default function RunStatusSelect({
  value,
  onChange,
}: {
  value: RunFilter;
  onChange: (value: RunFilter) => void;
}) {
  return (
    <Selector
      options={RUN_FILTERS}
      value={value}
      onValueChange={onChange}
      ariaLabel="Status"
      className="run-status-select"
    />
  );
}
